 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"CustomerTasks~Customers~Invoices~Login~Register~Settings~Statistics~TaskSelection~Tasks~Tracks":"CustomerTasks~Customers~Invoices~Login~Register~Settings~Statistics~TaskSelection~Tasks~Tracks","CustomerTasks~Customers~Invoices~Settings~Statistics~Tasks~Tracks":"CustomerTasks~Customers~Invoices~Settings~Statistics~Tasks~Tracks","CustomerTasks~Customers~Invoices~Tasks~Tracks":"CustomerTasks~Customers~Invoices~Tasks~Tracks","CustomerTasks":"CustomerTasks","Customers":"Customers","Invoices":"Invoices","Player~Statistics~Tracks":"Player~Statistics~Tracks","Tracks":"Tracks","Tasks":"Tasks","Statistics":"Statistics","Register~Settings":"Register~Settings","Settings":"Settings","Login":"Login","Register":"Register","DataPrivacy":"DataPrivacy","Imprint":"Imprint","Logout":"Logout","Notifications":"Notifications","Player":"Player","Verify":"Verify","InvoiceCreation":"InvoiceCreation","ConnectLexoffice":"ConnectLexoffice","TaskSelection":"TaskSelection"}[chunkId]||chunkId) + "." + {"CustomerTasks~Customers~Invoices~Login~Register~Settings~Statistics~TaskSelection~Tasks~Tracks":"5c6a9b6a","CustomerTasks~Customers~Invoices~Settings~Statistics~Tasks~Tracks":"773b86fe","CustomerTasks~Customers~Invoices~Tasks~Tracks":"0b7edc1b","CustomerTasks":"354b88e1","Customers":"bf16bb63","Invoices":"e55b1bf1","Player~Statistics~Tracks":"baec3dea","Tracks":"a4b6d6f9","Tasks":"e44a751a","Statistics":"870c904a","Register~Settings":"04cb9af9","Settings":"0ecef927","Login":"5800d538","Register":"9163afbb","DataPrivacy":"e8500ecc","Imprint":"a379cc5a","Logout":"df528f48","Notifications":"98ced350","Player":"89640cdc","Verify":"d44087ce","InvoiceCreation":"e66a5e70","ConnectLexoffice":"6c0bf7e7","TaskSelection":"b4992df8"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"CustomerTasks~Customers~Invoices~Login~Register~Settings~Statistics~TaskSelection~Tasks~Tracks":1,"CustomerTasks~Customers~Invoices~Settings~Statistics~Tasks~Tracks":1,"CustomerTasks~Customers~Invoices~Tasks~Tracks":1,"CustomerTasks":1,"Customers":1,"Invoices":1,"Tracks":1,"Tasks":1,"Statistics":1,"Login":1,"Register":1,"Notifications":1,"Player":1,"InvoiceCreation":1,"ConnectLexoffice":1,"TaskSelection":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"CustomerTasks~Customers~Invoices~Login~Register~Settings~Statistics~TaskSelection~Tasks~Tracks":"CustomerTasks~Customers~Invoices~Login~Register~Settings~Statistics~TaskSelection~Tasks~Tracks","CustomerTasks~Customers~Invoices~Settings~Statistics~Tasks~Tracks":"CustomerTasks~Customers~Invoices~Settings~Statistics~Tasks~Tracks","CustomerTasks~Customers~Invoices~Tasks~Tracks":"CustomerTasks~Customers~Invoices~Tasks~Tracks","CustomerTasks":"CustomerTasks","Customers":"Customers","Invoices":"Invoices","Player~Statistics~Tracks":"Player~Statistics~Tracks","Tracks":"Tracks","Tasks":"Tasks","Statistics":"Statistics","Register~Settings":"Register~Settings","Settings":"Settings","Login":"Login","Register":"Register","DataPrivacy":"DataPrivacy","Imprint":"Imprint","Logout":"Logout","Notifications":"Notifications","Player":"Player","Verify":"Verify","InvoiceCreation":"InvoiceCreation","ConnectLexoffice":"ConnectLexoffice","TaskSelection":"TaskSelection"}[chunkId]||chunkId) + "." + {"CustomerTasks~Customers~Invoices~Login~Register~Settings~Statistics~TaskSelection~Tasks~Tracks":"d4481170","CustomerTasks~Customers~Invoices~Settings~Statistics~Tasks~Tracks":"09113b6e","CustomerTasks~Customers~Invoices~Tasks~Tracks":"8f734cf8","CustomerTasks":"54ff9825","Customers":"c71953ff","Invoices":"f20cd0e6","Player~Statistics~Tracks":"31d6cfe0","Tracks":"33c604b7","Tasks":"2abc6e1f","Statistics":"f3c45254","Register~Settings":"31d6cfe0","Settings":"31d6cfe0","Login":"17f697ce","Register":"cc396de8","DataPrivacy":"31d6cfe0","Imprint":"31d6cfe0","Logout":"31d6cfe0","Notifications":"31b85913","Player":"e750f245","Verify":"31d6cfe0","InvoiceCreation":"726b3234","ConnectLexoffice":"525481b0","TaskSelection":"a6ac63e2"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
